import { ColDef } from "ag-grid-community";
import { RowDef } from "../../components/ag-grid-extensions/models/RowDef";
import i18n from "../../services/localization-service/i18n";
import { IDisabledRecipient } from "../../services/admin-report-data-service/Models";
import { getTimeframeTimeDisplayText } from "../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";

const projectRow = (
    entry: IDisabledRecipient): RowDef => {

    let row: RowDef = {
    };

    row['timestamp'] = getTimeframeTimeDisplayText(TimeframeTypeEnum.None, entry.timestamp);
    row['actionTaken'] = entry.actionTaken;
    row['userName'] = entry.userName;
    row['recipient'] = entry.recipient;
    row['recipientType'] = entry.recipientType;
    row['methodUsed'] = entry.methodUsed;
    row['changedBy'] = entry.changedBy;

    return row;
}

const DisabledRecipientsReportUtils = {

    createGridRows: function (entries: IDisabledRecipient[] | undefined): RowDef[] {

        const rows: RowDef[] = entries?.map((o) => {
            return projectRow(o);
        }) ?? [];

        return rows;
    },
    createGridColumns: function (): ColDef[] {

        let cols: ColDef[] = [{
            headerName: i18n.t("disabledRecipientsReport.timestamp") as string,
            field: 'timestamp',
            sort: 'desc',
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("disabledRecipientsReport.actionTaken") as string,
            field: "actionTaken",
            type: "text"
        }, {
            headerName: i18n.t("disabledRecipientsReport.userName") as string,
            field: "userName",
            //flex: 1,
            //minWidth: 200,
            type: "text, multiline"
        }, {
            headerName: i18n.t("disabledRecipientsReport.recipient") as string,
            field: "recipient",
            //flex: 1,
            //minWidth: 200,
            type: "text, multiline"
        }, {
            headerName: i18n.t("disabledRecipientsReport.recipientType") as string,
            field: "recipientType",
            type: "text"
        }, {

            headerName: i18n.t("disabledRecipientsReport.methodUsed") as string,
            field: "methodUsed",
            type: "text"
        }, {
            headerName: i18n.t("disabledRecipientsReport.changedBy") as string,
            field: "changedBy",
            type: "text, multiline"
        }];

        return cols;
    }
};

export default DisabledRecipientsReportUtils;
